var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"battles-banner",attrs:{"to":_vm.link}},[_c('img',{staticClass:"battles-banner__gif",attrs:{"src":"gifs/battles.gif"}})])}
var staticRenderFns = []

export { render, staticRenderFns }